import { createSlice } from '@reduxjs/toolkit';
import { DiagnosticForm, Diagnostic } from '../../types/types';

interface SetDiagnosticAction {
  payload: Diagnostic[];
  type: string;
}

const initialDiagnostic: DiagnosticForm = {
  data: [],
  adding: false,
  newDiagnostic: ''
};

const diagnosticSLice = createSlice({
  name: 'diagnostic',
  initialState: initialDiagnostic,
  reducers: {
    setDiagnostics(state, action: SetDiagnosticAction) {
      state.data = action.payload;
    },
    setAdding(state) {
      state.adding = !state.adding;
    },
    setNewDiagnostic(state, action) {
      state.newDiagnostic = action.payload;
    },
    reset() {
      return initialDiagnostic;
    }
  }
});

export const diagnosticActions = diagnosticSLice.actions;

export default diagnosticSLice.reducer;
